import api from "api"
import {
  IGetReservationsQueryParams,
  IUpdateReservationInfo,
  IRecalculateReservationAmountURLParams,
  IUpdateReservationBoxURLParams,
  ICancelReservationURLParams,
  ICreateWebReservation,
  IChangeBulkReservations,
  IUpdateReservationWasherURLParams,
} from "types/reservation"

const getReservations = (
  getBoxInfo: boolean,
  queryParams: IGetReservationsQueryParams,
) => {
  const {
    pageIndex,
    pageSize,
    sortBy,
    carWashIds,
    customerId,
    // onGoing,
    // reserved,
    // finished,
    // canceled,
    search,
    statusIds,
    vehicleBodyTypeIds,
    boxIds,
    washerIds,
    fromDate,
    toDate,
  } = queryParams
  let query = `pageIndex=${pageIndex}&pageSize=${pageSize}&sortBy=${sortBy}&fromDate=${fromDate}&toDate=${toDate}`

  // if (onGoing !== undefined) query += `&onGoing=${onGoing}`
  // if (reserved !== undefined) query += `&reserved=${reserved}`
  // if (finished !== undefined) query += `&finished=${finished}`
  // if (canceled !== undefined) query += `&canceled=${canceled}`
  if (search !== undefined) query += `&search=${search}`
  if (carWashIds !== undefined && carWashIds.length > 0) {
    carWashIds.forEach((id: number, i: number) => {
      query += `&carWashIds[${i}]=${id}`
    })
  }
  if (statusIds !== undefined && statusIds.length > 0) {
    statusIds.forEach((id: number, i: number) => {
      query += `&statusIds[${i}]=${id}`
    })
  }
  if (vehicleBodyTypeIds !== undefined && vehicleBodyTypeIds.length > 0) {
    vehicleBodyTypeIds.forEach((id: number, i: number) => {
      query += `&vehicleBodyTypeIds[${i}]=${id}`
    })
  }
  if (washerIds !== undefined && washerIds.length > 0) {
    washerIds.forEach((id: number, i: number) => {
      query += `&washerIds[${i}]=${id}`
    })
  }

  if (boxIds !== undefined && boxIds.length > 0) {
    boxIds.forEach((id: number, i: number) => {
      query += `&boxIds[${i}]=${id}`
    })
  }

  if (customerId !== undefined) query += `&customerId=${customerId}`

  return api.get(`/reservation/GetReservationPageData/${getBoxInfo}?${query}`)
}

const getReservation = (reservationId: number) =>
  api.get(`/reservation/getReservationDetailInfo/${reservationId}`)

const updateReservationStatus = (reservationId: number) =>
  api.post(`/reservation/updateReservationStatusByHierarchy/${reservationId}`)

const updateReservationInfo = (data: IUpdateReservationInfo) =>
  api.post("/reservation/updateReservationInfo", data)

const updateReservationBox = ({
  reservationId,
  box,
}: IUpdateReservationBoxURLParams) =>
  api.post(`/reservation/changeReservationBox/${reservationId}/${box}`)

const updateReservationWasher = ({
  reservationId,
  employeeId,
}: IUpdateReservationWasherURLParams) =>
  api.post(
    `/Reservation/ChangeReservationWasher/${reservationId}/${employeeId}`,
  )

const recalculateReservationAmount = ({
  reservationId,
  personVehicleId,
  washTypeId,
  vehicleBodyTypeId,
}: IRecalculateReservationAmountURLParams) =>
  api.post(
    `/reservation/recalculateReservationAmount/${reservationId}/${personVehicleId}/${washTypeId}/${vehicleBodyTypeId}`,
  )

const cancelReservation = ({
  reservationId,
  cancelBy,
}: ICancelReservationURLParams) =>
  api.post(`/reservation/cancelReservation/${reservationId}/${cancelBy}`)

const createWebReservation = (data: ICreateWebReservation) =>
  api.post("Reservation/CreateWebReservation", data)

const getBoxAssignInfo = (reservationId: number) =>
  api.get(`/reservation/GetBoxAssignInfo/${reservationId}`)

const getCarWashSchedule = (
  VehicleBodyTypeId: number,
  WashTypeId: number,
  CarWashId: number,
) =>
  api.get(
    `CarWash/GetCarWashSchedule?VehicleBodyTypeId=${VehicleBodyTypeId}&WashTypeId=${WashTypeId}&CarWashId=${CarWashId}`,
  )

const getCheckboxAvailability = (reservationId: number, box: number) =>
  api.get(`Reservation/CheckboxAvailability/${reservationId}/${box}`)

const markReservationAsPrinted = (reservationId: number) =>
  api.post(`Reservation/MarkReservationAsPrinted/${reservationId}`)

const setVehicleKeyStatus = (reservationId: number) =>
  api.post(`Reservation/SetVehicleKeyStatus/${reservationId}`)

const changeBulkReservationBox = (data: IChangeBulkReservations[]) =>
  api.post("Reservation/ChangeBulkReservationBox", data)

const verifyQueueReservations = (data: number[]) =>
  api.post("Reservation/VerifyqueueReservations", data)

const getCarWashDiscountTypes = (laundryId: number) =>
  api.get(`Reservation/GetCarWashDiscountTypes/${laundryId}`)

const getCarWashWashers = (carWashId: number) =>
  api.get(`CarWash/GetCarWashWashers/${carWashId}`)

const getCarWashBoxes = (carWashId: number) =>
  api.get(`CarWash/GetCarWashBoxCount/${carWashId}`)

export default {
  getReservations,
  getReservation,
  updateReservationStatus,
  updateReservationInfo,
  updateReservationBox,
  recalculateReservationAmount,
  cancelReservation,
  getBoxAssignInfo,
  getCarWashSchedule,
  createWebReservation,
  getCheckboxAvailability,
  markReservationAsPrinted,
  setVehicleKeyStatus,
  changeBulkReservationBox,
  verifyQueueReservations,
  getCarWashDiscountTypes,
  getCarWashWashers,
  getCarWashBoxes,
  updateReservationWasher,
}
